// Docs: https://connectrpc.com/docs/introduction

// @generated by protoc-gen-es v2.2.5 with parameter "target=ts"
// @generated from file entitlements/v3/features.proto (package entitlements.v3, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv1";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv1";
import { file_google_protobuf_descriptor } from "@bufbuild/protobuf/wkt";
import { file_common_v3_common } from "../../common/v3/common_pb";

/**
 * Describes the file entitlements/v3/features.proto.
 */
export const file_entitlements_v3_features: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_descriptor, file_common_v3_common]);

/**
 * Feature enumerates the capabilities available within the platform.
 * The enum values are organized into logical groupings with reserved number
 * ranges, allowing for systematic expansion of feature sets while maintaining
 * clear organizational boundaries.
 *
 * Features are made available through entitlements.
 *
 * @generated from enum entitlements.v3.Feature
 */
export enum Feature {
  /**
   * Default unspecified value. Should not be used directly.
   *
   * @generated from enum value: FEATURE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Enables diagnostic tools and information for system troubleshooting.
   * Provides access to UI tooling and other debugging interfaces.
   *
   * @generated from enum value: FEATURE_DIAGNOSTICS = 1;
   */
  DIAGNOSTICS = 1,

  /**
   * Allows administrators to impersonate other users for testing and support.
   * Enables verification of user-specific behaviors without credential sharing.
   *
   * @generated from enum value: FEATURE_PROXY_AS = 2;
   */
  PROXY_AS = 2,

  /**
   * Enables creation and management of organizational knowledge.
   * Provides tools for ingesting, organizing, and retrieving information.
   *
   * @generated from enum value: FEATURE_KNOWLEDGE_BASE = 10;
   */
  KNOWLEDGE_BASE = 10,

  /**
   * Enables creation, editing, and sharing of persistent content artifacts.
   * Provides version control and collaborative editing capabilities.
   *
   * @generated from enum value: FEATURE_ARTIFACTS = 100;
   */
  ARTIFACTS = 100,

  /**
   * Enables connections to third-party tools and data sources.
   * Provides authentication and data exchange capabilities
   * with external systems.
   *
   * @generated from enum value: FEATURE_INTEGRATIONS = 200;
   */
  INTEGRATIONS = 200,

  /**
   * Enables programmatic access to platform capabilities via APIs, SDKs,
   * and RPC interfaces.
   *
   * @generated from enum value: FEATURE_API_ACCESS = 300;
   */
  API_ACCESS = 300,

  /**
   * Enables projects for organizing knowledge, actions, and chats within
   * a workspace.
   *
   * @generated from enum value: FEATURE_PROJECTS = 400;
   */
  PROJECTS = 400,

  /**
   * Enables creation and management of isolated user or team workspaces.
   * Provides boundaries for data access and sharing permissions.
   *
   * @generated from enum value: FEATURE_WORKSPACES = 500;
   */
  WORKSPACES = 500,

  /**
   * Enables creation and management of user groups with shared permissions.
   * Provides collaboration tools and team-level resource allocation.
   *
   * @generated from enum value: FEATURE_TEAMS = 600;
   */
  TEAMS = 600,

  /**
   * Enables creation and management of organizational structures and policies.
   * Provides enterprise-wide settings, billing, and administrative controls.
   *
   * @generated from enum value: FEATURE_ORGANIZATIONS = 700;
   */
  ORGANIZATIONS = 700,

  /**
   * Enables creation and application of labels for organizing and filtering content.
   * Provides taxonomy management and hierarchical classification.
   *
   * @generated from enum value: FEATURE_LABELS = 800;
   */
  LABELS = 800,

  /**
   * Enables subscription to specific topics or channels for receiving
   * updates and notifications such as when a concept changes, an action
   * performs an analysis, or an insight is learned.
   *
   * @generated from enum value: FEATURE_SUBSCRIPTIONS = 900;
   */
  SUBSCRIPTIONS = 900,

  /**
   * Enables discovery and management of unified ideas formed from the
   * knowledge base.
   *
   * @generated from enum value: FEATURE_CONCEPTS = 1000;
   */
  CONCEPTS = 1000,

  /**
   * Enables automatic discovery of concepts from knowledge assets.
   *
   * @generated from enum value: FEATURE_CONCEPT_AUTO_DISCOVERY = 1001;
   */
  CONCEPT_AUTO_DISCOVERY = 1001,

  /**
   * Enables creation and management of reusable actions and workflows.
   *
   * @generated from enum value: FEATURE_ACTIONS = 100000;
   */
  ACTIONS = 100000,

  /**
   * Enables scheduling of actions to run at specific times or intervals.
   *
   * @generated from enum value: FEATURE_ACTION_SCHEDULING = 100001;
   */
  ACTION_SCHEDULING = 100001,

  /**
   * Enables actions to be automatically triggered based on specific
   * events or conditions.
   *
   * @generated from enum value: FEATURE_ACTION_AUTO_TRIGGERS = 100003;
   */
  ACTION_AUTO_TRIGGERS = 100003,

  /**
   * Enables standard, real-time inference mode for chat interactions.
   * Provides immediate responses optimized for conversational flow.
   *
   * @generated from enum value: FEATURE_CHAT_STYLE_DIRECT_INFERENCE = 500000;
   */
  CHAT_STYLE_DIRECT_INFERENCE = 500000,

  /**
   * Enables enhanced thinking mode with more comprehensive reasoning.
   * Provides deeper analysis and more thorough responses at the cost of latency.
   *
   * @generated from enum value: FEATURE_CHAT_STYLE_DELIBERATIVE_INFERENCE = 500001;
   */
  CHAT_STYLE_DELIBERATIVE_INFERENCE = 500001,

  /**
   * Enables text-based input for initiating and continuing conversations.
   * Provides standard typing interface for user prompts and queries.
   *
   * @generated from enum value: FEATURE_CHAT_PROMPT_WITH_TEXT = 501000;
   */
  CHAT_PROMPT_WITH_TEXT = 501000,

  /**
   * Enables audio input for initiating and continuing conversations.
   * Provides speech-to-text capabilities for voice interaction.
   *
   * @generated from enum value: FEATURE_CHAT_PROMPT_WITH_AUDIO = 501002;
   */
  CHAT_PROMPT_WITH_AUDIO = 501002,

  /**
   * Enables customization of prompt templates and system instructions.
   * Provides tools for defining reusable conversation starters.
   *
   * @generated from enum value: FEATURE_CHAT_PROMPT_PERSONALIZATION = 501003;
   */
  CHAT_PROMPT_PERSONALIZATION = 501003,

  /**
   * Enables user-specific adaptations in conversation style and content.
   * Provides preference management for tailoring interactions to individual users.
   *
   * @generated from enum value: FEATURE_CHAT_PERSONALIZATION = 502000;
   */
  CHAT_PERSONALIZATION = 502000,

  /**
   * Enables enhanced visualizations to supplement text responses.
   * Provides charts, graphs, and other visual elements to enrich conversations.
   *
   * @generated from enum value: FEATURE_CHAT_TOOL_VISUALIZATIONS = 502001;
   */
  CHAT_TOOL_VISUALIZATIONS = 502001,

  /**
   * Enables web search capabilities within chat interactions using OpenAI's
   * web search tool. Provides access to real-time information from the web.
   *
   * @generated from enum value: FEATURE_WEB_SEARCH_OPEN_AI_GPT41 = 502002;
   */
  WEB_SEARCH_OPEN_AI_GPT41 = 502002,

  /**
   * Enables web search capabilities for tools.
   * Provides access to real-time web search through Exa API.
   *
   * @generated from enum value: FEATURE_TOOL_WEB_SEARCH = 502003;
   */
  TOOL_WEB_SEARCH = 502003,

  /**
   * Enables web page fetch capabilities for tools.
   * Provides access to fetch and parse web pages through Exa API.
   *
   * @generated from enum value: FEATURE_TOOL_WEB_PAGE = 502004;
   */
  TOOL_WEB_PAGE = 502004,

  /**
   * Enables image generation capabilities for tools.
   * Provides access to DALL-E, Gemini Imagen, and Banana image generation.
   *
   * @generated from enum value: FEATURE_TOOL_IMAGE_GENERATION = 502005;
   */
  TOOL_IMAGE_GENERATION = 502005,

  /**
   * Enables knowledge base search capabilities for tools.
   * Provides access to search across uploaded knowledge assets.
   *
   * @generated from enum value: FEATURE_TOOL_KB_SEARCH = 502006;
   */
  TOOL_KB_SEARCH = 502006,

  /**
   * Enables access to Storytell ruleset model.
   * Provides a ruleset model for Storytell.
   *
   * @generated from enum value: FEATURE_MODEL_STORYTELL_RULESET = 1000000;
   */
  MODEL_STORYTELL_RULESET = 1000000,

  /**
   * Enables story-tell to automatically select the best model for the task.
   *
   * @generated from enum value: FEATURE_MODEL_STORYTELL_AUTO_SELECT = 1000001;
   */
  MODEL_STORYTELL_AUTO_SELECT = 1000001,

  /**
   * Enables access to Storytell curated model selection.
   * Provides curated model recommendations based on task requirements.
   *
   * @generated from enum value: FEATURE_MODEL_STORYTELL_CURATED = 1000002;
   */
  MODEL_STORYTELL_CURATED = 1000002,

  /**
   * @generated from enum value: FEATURE_MODEL_STORYTELL_AGENT_V3 = 1000003;
   */
  MODEL_STORYTELL_AGENT_V3 = 1000003,

  /**
   * Enables access to Anthropic Claude 3.5 Sonnet model.
   * Provides balanced performance across reasoning, creativity, and speed.
   *
   * @generated from enum value: FEATURE_MODEL_ANTHROPIC_CLAUDE_35_SONNET = 1100000;
   */
  MODEL_ANTHROPIC_CLAUDE_35_SONNET = 1100000,

  /**
   * Enables access to Anthropic Claude 3.7 Sonnet model.
   * Provides enhanced capabilities over the 3.5 version with improved reasoning.
   *
   * @generated from enum value: FEATURE_MODEL_ANTHROPIC_CLAUDE_37_SONNET = 1100001;
   */
  MODEL_ANTHROPIC_CLAUDE_37_SONNET = 1100001,

  /**
   * Enables access to Anthropic Claude 3.7 Sonnet Thinking model.
   * Provides enhanced reasoning with explicit thinking process.
   *
   * @generated from enum value: FEATURE_MODEL_ANTHROPIC_CLAUDE_37_SONNET_THINKING = 1100002;
   */
  MODEL_ANTHROPIC_CLAUDE_37_SONNET_THINKING = 1100002,

  /**
   * Enables access to Anthropic Claude 4 Sonnet model.
   * Provides the latest capabilities with improved performance.
   *
   * @generated from enum value: FEATURE_MODEL_ANTHROPIC_CLAUDE_4_SONNET = 1100003;
   */
  MODEL_ANTHROPIC_CLAUDE_4_SONNET = 1100003,

  /**
   * Enables access to Anthropic Claude 4 Sonnet Thinking model.
   * Provides the latest capabilities with explicit thinking process.
   *
   * @generated from enum value: FEATURE_MODEL_ANTHROPIC_CLAUDE_4_SONNET_THINKING = 1100004;
   */
  MODEL_ANTHROPIC_CLAUDE_4_SONNET_THINKING = 1100004,

  /**
   * Enables access to Anthropic Claude 4.5 Sonnet model.
   * Provides enhanced capabilities with improved reasoning and performance.
   *
   * @generated from enum value: FEATURE_MODEL_ANTHROPIC_CLAUDE_45_SONNET = 1100005;
   */
  MODEL_ANTHROPIC_CLAUDE_45_SONNET = 1100005,

  /**
   * Enables access to OpenAI GPT-4.1 model.
   * Provides their flagship large language model with comprehensive capabilities.
   *
   * @generated from enum value: FEATURE_MODEL_OPENAI_GPT_41 = 1200000;
   */
  MODEL_OPENAI_GPT_41 = 1200000,

  /**
   * Enables access to OpenAI GPT-4.1 Mini model.
   * Provides a smaller, faster variant with reduced capabilities.
   *
   * @generated from enum value: FEATURE_MODEL_OPENAI_GPT_41_MINI = 1200001;
   */
  MODEL_OPENAI_GPT_41_MINI = 1200001,

  /**
   * Enables access to OpenAI GPT-4.1 Nano model.
   * Provides the smallest, fastest variant optimized for low-latency use cases.
   *
   * @generated from enum value: FEATURE_MODEL_OPENAI_GPT_41_NANO = 1200002;
   */
  MODEL_OPENAI_GPT_41_NANO = 1200002,

  /**
   * Enables access to OpenAI o3 model.
   * Provides specialized capabilities for specific use cases.
   *
   * @generated from enum value: FEATURE_MODEL_OPENAI_03 = 1200003;
   */
  MODEL_OPENAI_03 = 1200003,

  /**
   * Enables access to OpenAI o4 Mini model.
   * Provides efficient performance for lighter workloads.
   *
   * @generated from enum value: FEATURE_MODEL_OPENAI_04_MINI = 1200004;
   */
  MODEL_OPENAI_04_MINI = 1200004,

  /**
   * Enables access to OpenAI GPT-5 model.
   * Provides next-generation large language model with advanced capabilities.
   *
   * @generated from enum value: FEATURE_MODEL_OPENAI_GPT_5 = 1200005;
   */
  MODEL_OPENAI_GPT_5 = 1200005,

  /**
   * Enables access to OpenAI GPT-5 Mini model.
   * Provides a balanced variant optimized for cost-efficiency.
   *
   * @generated from enum value: FEATURE_MODEL_OPENAI_GPT_5_MINI = 1200006;
   */
  MODEL_OPENAI_GPT_5_MINI = 1200006,

  /**
   * Enables access to OpenAI GPT-5 Nano model.
   * Provides a lightweight variant optimized for speed and low-latency.
   *
   * @generated from enum value: FEATURE_MODEL_OPENAI_GPT_5_NANO = 1200007;
   */
  MODEL_OPENAI_GPT_5_NANO = 1200007,

  /**
   * Enables access to Google Gemini 2.0 Flash Lite model.
   * Provides lightweight, high-speed inference optimized for real-time applications.
   *
   * @generated from enum value: FEATURE_MODEL_GOOGLE_GEMINI_20_FLASH_LITE = 1300000;
   */
  MODEL_GOOGLE_GEMINI_20_FLASH_LITE = 1300000,

  /**
   * Enables access to Google Gemini 2.5 Pro model.
   * Provides enhanced reasoning and multimodal capabilities.
   *
   * @generated from enum value: FEATURE_MODEL_GOOGLE_GEMINI_25_PRO = 1300001;
   */
  MODEL_GOOGLE_GEMINI_25_PRO = 1300001,

  /**
   * Enables access to Google Gemini 2.5 Flash model.
   * Provides fast inference with enhanced capabilities.
   *
   * @generated from enum value: FEATURE_MODEL_GOOGLE_GEMINI_25_FLASH = 1300002;
   */
  MODEL_GOOGLE_GEMINI_25_FLASH = 1300002,

  /**
   * Enables access to Google Gemini 2.5 Flash Thinking model.
   * Provides fast inference with explicit thinking process.
   *
   * @generated from enum value: FEATURE_MODEL_GOOGLE_GEMINI_25_FLASH_THINKING = 1300003;
   */
  MODEL_GOOGLE_GEMINI_25_FLASH_THINKING = 1300003,

  /**
   * Enables access to Meta Llama 3 70B Versatile model.
   * Provides a general-purpose model with balanced capabilities.
   *
   * @generated from enum value: FEATURE_MODEL_META_LLAMA_3370B_VERSATILE = 1400000;
   */
  MODEL_META_LLAMA_3370B_VERSATILE = 1400000,

  /**
   * Enables access to Meta Llama 4 Scout model.
   * Provides specialized capabilities for exploration and discovery tasks.
   *
   * @generated from enum value: FEATURE_MODEL_META_LLAMA_4_SCOUT = 1400001;
   */
  MODEL_META_LLAMA_4_SCOUT = 1400001,

  /**
   * Enables access to Meta Llama 4 Maverick model.
   * Provides advanced capabilities for complex reasoning tasks.
   *
   * @generated from enum value: FEATURE_MODEL_META_LLAMA_4_MAVERICK = 1400002;
   */
  MODEL_META_LLAMA_4_MAVERICK = 1400002,

  /**
   * Enables access to DeepSeek R1 Distill Llama 70B model.
   * Provides a distilled version with efficient performance characteristics.
   *
   * @generated from enum value: FEATURE_MODEL_DEEPSEEK_R1_DISTILL_LLAMA_70B = 1500000;
   */
  MODEL_DEEPSEEK_R1_DISTILL_LLAMA_70B = 1500000,

  /**
   * Enables access to DeepSeek R1 Distill Qwen 7B model.
   * Provides a smaller, efficient distilled version.
   *
   * @generated from enum value: FEATURE_MODEL_DEEPSEEK_R1_DISTILL_QWEN_7B = 1500001;
   */
  MODEL_DEEPSEEK_R1_DISTILL_QWEN_7B = 1500001,
}

/**
 * Describes the enum entitlements.v3.Feature.
 */
export const FeatureSchema: GenEnum<Feature> = /*@__PURE__*/
  enumDesc(file_entitlements_v3_features, 0);

